export const COMPLIANCE_DOCS_ANCHOR = 'compliance-required-documents';

export function complianceUploadEntry(pathname, { learningOnly = false } = {}) {
  if (learningOnly) {
    return { kind: 'navigate', to: '/profile/learning', id: null };
  }
  const path = pathname || '';
  if (path === '/profile/compliance' || path.startsWith('/profile/compliance/')) {
    return { kind: 'scroll', to: '/profile/compliance', id: COMPLIANCE_DOCS_ANCHOR };
  }
  return { kind: 'navigate', to: '/profile/compliance', id: null };
}
